import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { mapToMapExpression } from '@angular/compiler/src/render3/util';
import { Injectable } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, filter, map, shareReplay } from 'rxjs/operators';
import { Usuario } from 'src/app/models/usuario';
import { environment } from 'src/environments/environment';
import { UsuariosService } from '../data/usuarios.service';
import { PermisoModulos } from '../models/permisoModulo/permisoModulo';
import { HttprService } from './httpr.service';
import { UsuarioService } from './usuario.service';

@Injectable({ providedIn: 'root' })
export class PermisosModulosService {
    permisosModulos = new PermisoModulos();
    permisosModulosS= new PermisoModulos();
    private permisosModulos$: any;

    permisoList:any;

    constructor(
        private http: HttprService,public router: Router,
        private usuario:UsuarioService
      ) {
      this.router.events.pipe(filter(event => event instanceof ActivationEnd)).subscribe((event: ActivationEnd) => {
        if (event.snapshot.data.modulo) {
          this.permisosModulos.moduloString = event.snapshot.data.modulo;
        }
      });
       // this.recuperaPermisoModulos();
    }

    async recuperaPermisoModuloUsuarios<PermisoModulos>(modulo:string ="") {
      this.permisosModulos.idUsuario = Number(this.usuario.actual?.idUsuario);
      this.permisosModulos.moduloString = modulo;

      return await this.http.POST<PermisoModulos>("/permisoModulos/recuperaPermisosModulosUsuarios", this.permisosModulos).toPromise();
    }

     recuperaPermisoModuloUsuariosNew(modulo:string ="") {
      this.permisosModulos.idUsuario = Number(this.usuario.actual?.idUsuario);
      this.permisosModulos.moduloString = modulo;

        this.permisoList = this.http.POST<PermisoModulos[]>("/permisoModulos/recuperaPermisosModulosUsuarios", this.permisosModulos);
        console.log("this.permisoList",this.permisoList)
        return this.permisoList;
    }


    obtenerPermisosModulos(){
      return this.permisoList;
    }

     recuperaPermisoModulos(modulo = new PermisoModulos()) {
      return  this.http.POST<PermisoModulos[]>("/permisoModulos/recuperaPermisosModulos", modulo);
    }

    guardaModulosUsuario(modulo = new PermisoModulos()){
      return  this.http.POST<PermisoModulos[]>("/permisoModulos/guardaPermisoModulosUsuario", modulo);
    }
}
